import { Link } from 'react-router-dom';

import { SearchBar } from '../SearchBar/component.tsx';

import styles from './component.module.scss';

export const SubHeader = () => {
  return (
    <div className={styles.main}>
      <h1>
        <Link to="/">
          <span className={styles.dorTitle}>DOR</span> Metagraph Explorer
        </Link>
      </h1>
      <SearchBar />
    </div>
  );
};
